import loadScriptCallback from 'load-script'

type Options = Parameters<typeof loadScriptCallback>[1]

async function loadScript(url: string, opts: Options = {}) {
	return new Promise<HTMLScriptElement>((resolve, reject) => {
		loadScriptCallback(url, opts, (err, script) => {
			if (err) {
				reject(err)
			} else {
				resolve(script)
			}
		})
	})
}

export default loadScript
